export function isValidNumber(value) {
  const regex = /^[-+]?(\d+(\.\d*)?|\.\d+)$/;
  return regex.test(value);
}
